export interface SalesOrderAllocation {
  id: string;
  salesOrderAndLineNo: string;
  productKey: string;
  productDescription: string;
  productType: string;
  supplierKey: string;
  supplierName: string;
  orderNo: string;
  allocationType: string;
  allocated: number;
}
